import { useCallback } from "react";
import { ProductsApi, useAPIAction } from "melco-shared-logic";
import { useParams } from "react-router-dom";

export const useUserProductGetVersions = () => {
  const { userId } = useParams<{
    userId: string;
  }>();

  const [GetVersionsProducts] = useAPIAction(
    ProductsApi,
    async (api, productCode: string) => {
      const data = await api.productsGetVersionList({
        productCode,
      });

      return {
        successMessages: [],
        data,
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: userId },
      translationPrefix: "",
    }
  );

  return useCallback(
    async (productCode: string) => {
      //const successfullyGetVersionsId: string[] = [];
      try {
        return await GetVersionsProducts(productCode);
        //successfullyGetVersionsId.push(productCode);
      } catch (e) {
        // exception already handled in useAPIAction
      }
      //return successfullyGetVersionsed;
    },
    [GetVersionsProducts]
  );
};
